/**
 * Map known English API / toast bodies to i18n keys.
 * Unknown text passes through unchanged (same pattern as notificationMessage).
 * Expand this map as new untranslated API screenshots are fixed.
 */
export function localizeApiMessage(message, t) {
  if (message == null || message === '') return message;
  const raw = String(message).trim();

  const exact = {
    'Invalid Email! Please Try Again': t('toasts.invalidEmail'),
    'Withdrawal request has been successfully processed.': t(
      'toasts.withdrawRequestSuccess',
    ),
    'Withdrawal request has been successfully processed': t(
      'toasts.withdrawRequestSuccess',
    ),
    'Withdraw request submitted successfully!': t('toasts.withdrawRequestSuccess'),
    'Withdraw request submitted successfully': t('toasts.withdrawRequestSuccess'),
  };
  if (exact[raw]) return exact[raw];

  // Tolerate minor casing/punctuation drift from the API
  const normalized = raw.replace(/\s+/g, ' ').toLowerCase().replace(/\.$/, '');
  if (normalized === 'invalid email! please try again') {
    return t('toasts.invalidEmail');
  }
  if (
    normalized === 'withdrawal request has been successfully processed' ||
    normalized === 'withdraw request submitted successfully!' ||
    normalized === 'withdraw request submitted successfully'
  ) {
    return t('toasts.withdrawRequestSuccess');
  }

  return raw;
}
